import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'properCase'})
export class ProperCasePipe implements PipeTransform
{
    transform(value: string, args: any[] = []): string
    {
        return value ? String(value).replace(/([A-Z])/g, (g) => ` ${g[0].toLowerCase()}`) : '';
    }
}
